import {
  ALLOWED_HTML_ATTRIBUTES,
  ALLOWED_HTML_TAGS,
} from '@conversed/shared/src/central/constants/html-sanitization.constants';
import domPurify from 'dompurify';

export const splitIntoLines = (text?: string) => {
  if (!text) {
    return '';
  }

  return text.split('\n').map((str, index) => {
    if (str !== '') {
      return (
        <p key={index} className='text-normal text-sm'>
          {str}
        </p>
      );
    }
    return <br key={index} />;
  });
};

export const purify = (text: string, extraClass = '') => {
  const dompurifyConfig = {
    ALLOWED_TAGS: [...ALLOWED_HTML_TAGS],
    ALLOWED_ATTR: [...ALLOWED_HTML_ATTRIBUTES],
    FORCE_BODY: false,
  };

  // Add hook to automatically set target="_blank" for all <a> tags
  domPurify.addHook('afterSanitizeAttributes', (node) => {
    // Set all links to open in a new tab
    if ('target' in node) {
      node.setAttribute('target', '_blank');
      // Add rel="noopener noreferrer" for security
      node.setAttribute('rel', 'noopener noreferrer');
      // Add the markdown-link class, this will apply the appropriate style.
      node.setAttribute('class', `markdown-link ${extraClass}`);
    }
  });

  const purifiedText = domPurify.sanitize(text, dompurifyConfig);

  // Remove the hook to avoid affecting other uses of DOMPurify
  domPurify.removeHook('afterSanitizeAttributes');

  return purifiedText;
};
